import * as yup from 'yup'

export function getReservationSchema({ isStaff }) {
    return yup.object().shape({
        user: yup
            .number()
            .when([], {
                is: () => isStaff,
                then: schema => schema.required('O campo Profissional é obrigatório'),
                otherwise: schema => schema.notRequired().nullable()
            }),
        headquarter: yup
            .number()
            .required('O campo Sede é obrigatório'),
        room: yup
            .number()
            .required('O campo Sala é obrigatório'),
        locationType: yup
            .string()
            .oneOf(['Avulsa', 'Fixa'], 'O campo Tipo de reserva é obrigatório')
            .required('O campo Tipo de reserva é obrigatório'),
        locationDate: yup
            .date()
            .typeError('Data inválida')
            .required('O campo Data é obrigatório')
            .when([], {
                is: () => isStaff,
                then: schema => schema,
                otherwise: schema => schema.min(
                    new Date(new Date().setHours(0, 0, 0, 0)),
                    'A data deve ser igual ou posterior a hoje'
                )
            }),
        locationHour: yup
            .number()
            .required('O campo Horário é obrigatório'),
    })
}
